
















































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { doublePrevention, performanceServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { PagingUnit, CollapseTransition, TreeUnit },
  mixins: [TableStripe],
})
export default class User extends Vue {
  @Watch('formData.search')
  filterText(val: any) {
    (this.$refs as any).tree.filter(val);
  }
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据
  openFlag = true; // 控制左侧导航栏是否显示

  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };
  formData: any = {
    search: '',
    dangerSource: '',
    riskPoint: '',
    executeDepartmentId: '',
  };

  seletedPost: any = {}; // 存储被选择的岗位

  treeData: any = [];

  checkNode: any = {}; // 选中的节点数据

  tableData: any = [];
  hazardList: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [];

  // 风险点
  riskPointList: any = [];

  // 危险源
  dangerSourceIdList: any = [];

  helpDangerSourceIdList: any = []; // 存放所有type是危险源的下拉

  // Vue创建数据声明周期钩子函数
  created() {
    this.hazardList = [];
    this.seletedPost = {};
    this.getTreeData();
    // 获取分页数据
    this.getPageData();
    this.getSubSpaceByAuth();
    this.getRiskData();
  }

  getDangerSourceIdList(name: any) {
    if (name) {
      this.dangerSourceIdList = [];
      this.formData.dangerSource = '';
      const selectedName = this.riskPointList.find((item: any) => {
        return item.id === name;
      });
      this.helpDangerSourceIdList.forEach((res: any) => {
        if (res.pid === selectedName.id) {
          this.dangerSourceIdList.push(res);
        }
      });
    } else {
      this.dangerSourceIdList = [];
      this.formData.dangerSource = '';
    }
  }

  // 获取风险点和危险源的下拉
  getRiskData() {
    doublePrevention.getRiskAll({}).then((res: any) => {
      if (res.code === '200') {
        res.data.forEach((type: any) => {
          if (type.type === '风险点') {
            this.riskPointList.push(type);
          }
          if (type.type === '危险源') {
            this.helpDangerSourceIdList.push(type);
          }
        });
      } else {
        this.$message.warning('获取风险点和危险源的数据失败！');
      }
    });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    doublePrevention
      .getRiskControlHazardTemplate({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        hazardCategoryTagId: this.formData.executeDepartmentId ? this.formData.executeDepartmentId : null,
        riskPointId: this.formData.riskPoint ? this.formData.riskPoint : null,
        dangerSourceId: this.formData.dangerSource ? this.formData.dangerSource : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailsByTreeId(id: any) {
    // 发起接口请求，获取分页数据
    doublePrevention
      .getPostHazardCheckDetail(id)
      .then((res: any) => {
        if (res.data && res.data.length > 0) {
          this.hazardList = res.data;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    performanceServer
      .getTagManageList({ type: 'hazardClassify' })
      .then((res: any) => {
        res.data.forEach((r: any) => {
          if (r.children && r.children.length > 0) {
            this.diguiPost(r.children);
          } else {
            r.children = undefined;
          }
        });
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  getChangeArea(data: any) {
    this.formData.executeDepartmentId = data.slice(-1).toString();
  }

  selectHiddenList(data: any) {
    const index = this.hazardList.findIndex((item: any) => item.id === data.id);
    if (index > -1) {
      // 有
      this.$message.warning('被选中隐患排查清单已存在该条数据！');
    } else {
      // 无
      this.hazardList.push(data);
    }
  }

  deleteHiddenList(index: any) {
    this.hazardList.splice(index, 1);
  }

  /**
   * @desc 添加
   */
  operationBinding() {
    if (this.seletedPost.type === '部门') {
      this.$message.warning('请选择岗位！');
      return;
    } else {
      const newList: any = [];
      this.hazardList.forEach((r: any) => {
        newList.push(r.id);
      });
      const newObj: any = {
        postId: this.seletedPost.id,
        templateIds: newList,
      };
      doublePrevention
        .addPostHazardCheck(newObj)
        .then((res: any) => {
          if (res.code === '200') {
            this.$message.success('新增成功！');
            this.hazardList = [];
            this.resetFormData();
            this.getTreeData();
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((error: any) => {
          this.$message.warning('新增数据失败！');
        });
    }
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      search: '',
      dangerSource: '',
      riskPoint: '',
      executeDepartmentId: '',
    };
    this.getPageData();
  }

  filterNode(value: any, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }

  diguiPost(data: any) {
    data.map((res: any, index: any) => {
      if (res.children && res.children.length > 0) {
        this.digui(res.children);
      } else {
        res.children = undefined;
      }
    });
    return data;
  }

  digui(data: any) {
    data.map((res: any, index: any) => {
      if (res.type === '部门') {
        res.disabled = true;
      }
      if (res.children && res.children.length > 0) {
        this.digui(res.children);
      }
    });
    return data;
  }

  getTreeData() {
    doublePrevention
      .getSpacePostAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          // this.treeData = this.digui(res.data)
          this.treeData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('初始化树形图数据失败!');
      });
  }

  nodeClick(item: any) {
    this.hazardList = [];
    this.seletedPost = item;
    if (item.type === '部门') {
      (this.$refs as any).tree.setCurrentKey(null);
      // this.$message.warning('部门不允许操作，请选择岗位！');
    } else {
      this.getDetailsByTreeId(item.id);
    }
  }

  /**
   * desc： 控制组织树形图显示隐藏
   */
  toggleOpen() {
    this.openFlag = !this.openFlag;
  }

  mapClick() {}

  // dom 挂载完成阶段
  mounted(): void {}
}
